export default __webpack_public_path__ + "secondary-header.png";